import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { TableMunicipio } from "./tableMunicipio";
import { Municipio } from "./estadoMunType";
import { RequestError, useApi } from "../../services";
import { ErrorOnDialog, LoadingModal } from "../modals";

export const SelectMunicipio: React.FC<{
  variant?: "text" | "contained" | "outlined";
  municipio?: Municipio | number;
  onChoose?: (municipio: Municipio) => void;
}> = ({ onChoose, municipio, variant }) => {
  const api = useApi();

  const [_municipio, setMunicipio] = useState(municipio);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState<RequestError>();

  useEffect(() => {
    if (typeof municipio === "number") {
      api.estadosMunicipios.getMunicipio(municipio).then((value) => {
        if ("error" in value) {
          setError(value);
          return;
        }
        setMunicipio(value);
      });
    }
  }, []);

  const handleSelect = (municipio: Municipio) => {
    setOpen(false);
    setMunicipio(municipio);
    if (onChoose) onChoose(municipio);
  };

  if (error) {
    return <>
      {error && <ErrorOnDialog
        open={Boolean(error)}
        error={error.error}
        message={error.message}
        onClose={() => setError(undefined)}
      />}
    </>;
  }

  if (typeof _municipio === "number") {
    return <LoadingModal open />;
  }

  return <>
    <Dialog
      fullWidth
      open={open}
      maxWidth={"md"}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>
        Selecionar Município
      </DialogTitle>
      <DialogContent>
        <TableMunicipio onChoose={handleSelect} />
      </DialogContent>
    </Dialog>
    <Button
      fullWidth
      variant={variant}
      onClick={() => setOpen(true)}
    >
      {_municipio?.nome ?? "Selecionar Município"}
    </Button>
  </>;
};